// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__dNkCM","paramInput":"JobSimulator_paramInput__1or91","input":"JobSimulator_input__YFOJj"};